import { useMemo } from 'react';
import useSWR from 'swr';

import { uniq } from '@/utils/common';
import { cheryInstance } from '@/api';
import { TDealer } from '@/types/common';

export type TDealerData = {
  DealerId: number;
  DealerPointId: number;
  DealerCode: string;
  Descr: string;
  Address: string | null;
  City: string | null;
};

const getDealers = async endpoint => {
  const { data } = await cheryInstance.get<TDealerData[]>(endpoint);
  return data;
};

const useDealerLSDataFetch = () => {
  const { data: dealerData, error } = useSWR(`dealers-list/index.json`, getDealers);

  const { dealers, cities } = useMemo(() => {
    const filteredDealers =
      dealerData?.reduce((acc, { DealerId, Descr, City }) => {
        if (!City) return acc;
        return [
          ...acc,
          {
            id: DealerId,
            title: Descr,
            city: City,
          },
        ];
      }, [] as TDealer[]) ?? [];
    return {
      dealers: filteredDealers,
      cities: uniq(filteredDealers.map(({ city }) => city)),
    };
  }, [dealerData]);

  const getDealersByCity = city => {
    if (!city) return [];
    return dealers.filter(d => d.city === city);
  };

  return { data: { dealers, cities }, loading: !dealerData, error, getDealersByCity };
};

export default useDealerLSDataFetch;
